{
  "errorCodes": {
    "COMPLAINT_ALREADY_EXIST": "Ushbu e'lon uchun shikoyat allaqachon mavjud.",
    "ACCOUNT_NAME_IS_ALREADY_TAKEN": "Bunday hisob nomi band.",
    "INVALID_CONFIRMATION_CODE": "Noto'g'ri kod.",
    "TOO_SMALL_IMAGE": "Rasm juda kichik.",
    "NOT_FOUND": "Ma'lumot topilmadi.",
    "ACCOUNT_BLOCKED": "Hisobingiz bloklangan yoki faol emas.",
    "ACCESS_DENIED": "Kechirasiz! Kirish taqiqlangan.",
    "ARTICLE_LIMIT_EXCEEDED": "Maqolalar limiti oshib ketdi.",
    "EDIT_NOT_ALLOWED": "Tahrirlashga ruxsat berilmagan.",
    "DISCARD_CHANGES_NOT_ALLOWED": "O'zgarishlarni bekor qilishga ruxsat berilmagan.",
    "TOO_MANY_ATTEMPTS": "Juda ko'p urinishlar.",
    "MODERATION_NOT_ALLOWED": "Moderatsiyaga ruxsat berilmagan.",
    "UNSUITABLE_RELATION": "Noto'g'ri bog'liqlik.",
    "BOOKING_ALREADY_CANCELED": "Bron bekor qilingan.",
    "COMPANY_LIMIT_EXCEEDED": "Tashkilotchilar limiti oshib ketdi.",
    "INVALID_PHONE_NUMBER": "Raqam formati noto'g'ri.",
    "INVALID_FILE_TYPE": "Noto'g'ri fayl turi.",
    "UPLOAD_ALREADY_IN_USE": "Yuklash allaqachon amalga oshirilmoqda.",
    "ALIEN_UPLOAD": "«Noma'lum» narsa yuklanmoqda.",
    "PROMOTION_ORDER_REVOKE_NOT_ALLOWED": "Reklama buyurtmasini bekor qilishga ruxsat berilmagan.",
    "PROMOTION_PAYMENT_NOT_ALLOWED": "Reklama to'loviga ruxsat berilmagan.",
    "INVALID_PROMOTION_ORDER_STATUS": "Reklama buyurtmasining noto'g'ri holati.",
    "PROMOTION_ORDER_EXISTS": "Reklama buyurtmasi allaqachon mavjud.",
    "SPECIALIST_LIMIT_EXCEEDED": "Mutaxassislar limiti oshib ketdi.",
    "TREATMENT_LIMIT_EXCEEDED": "Tadbirlar limiti oshib ketdi.",
    "INACCURATE_LOCATION_EXCEPTION": "Noaniq joylashuv.",
    "EMPTY_CHANGE_REQUEST": "Saqlash uchun o'zgarishlar yo'q.",
    "COMMENT_LIMIT_EXCEEDED": "Sharhlar limiti oshib ketdi.",
    "ALIEN_DEVICE_UUID": "«Noma'lum» qurilma UUID.",
    "ALREADY_SIGNED_IN": "Siz allaqachon tizimga kirgansiz.",
    "BAD_CREDENTIALS": "Noto'g'ri avtorizatsiya ma'lumotlari.",
    "INSECURE_PASSWORD": "Xavfsiz bo'lmagan parol.",
    "INVALID_CURRENT_PASSWORD": "Joriy parol noto'g'ri.",
    "BANNED_CONTENT": "Taqiqlangan kontent.",
    "TOO_MANY_UPLOADS": "Juda ko'p yuklamalar.",
    "EMAIL_IS_ALREADY_TAKEN": "Elektron pochta allaqachon band.",
    "INVALID_BIRTHDAY": "Noto'g'ri tug'ilgan sana.",
    "BOOKING_ALREADY_EXISTS": "Siz ushbu tadbir uchun allaqachon bron qildingiz.",
    "REVIEW_LIMIT_EXCEEDED": "Sharhlar limiti oshib ketdi.",
    "REGION_CHANGE_NOT_ALLOWED": "Ushbu e'lonning hududini o'zgartirib bo'lmaydi.",
    "UNKNOWN_ERROR": "Biror narsa noto'g'ri ketdi.",
    "UNKNOWN_REGION": "Ushbu viloyat qo'llab-quvvatlanmaydi",
    "AVATARS_LIST_LOADING_ERROR": "Yuklashda xatolik. Sahifani yangilang",
    "ACCESS_TOKEN_EXPIRED": "Kirish tokeni muddati tugagan yoki bekor qilingan",
    "ACCESS_TOKEN_INVALID": "Noto'g'ri kirish tokeni"
  },
  "successCodes": {
    "PROFILE_UPDATED": "Profil muvaffaqiyatli yangilandi"
  },
  "validations": {
    "requiredField": "Bu maydon to'ldirilishi shart",
    "contactMethodRequired": "Kamida bitta aloqa usulini kiriting",
    "maxOfferNameLength": "{{maxLength}} ta belgi limiti tugadi",
    "maxOfferDescriptionLength": "Chegaradan oshib ketdi",
    "minOfferDescriptionLength": "Maydonni to‘ldiring: kamida {{minLength}} ta belgi",
    "categoryRequiredField": "Kategoriyani tanlang",
    "nameRequiredField": "Ismingizni kiriting",
    "newOfferContactWayRequired": "Aloqa usulini tanlang",
    "serviceRequired": "Xizmatni tanlang"
  },
  "currency": {
    "uzs": "so'm",
    "usd": "y.e."
  },
  "sorting": {
    "title": "Saralash",
    "titleMobile": "Saralash",
    "recommended": "Tavsiya etilgan",
    "new": "Avval yangilar",
    "cheap": "Avval arzonroq",
    "expensive": "Avval qimmatroq"
  },
  "emptySearch": {
    "title": "Siz izlayotgan narsani topa olmadik",
    "text": "Qidiruv so'rovini o'zgartirib ko'ring",
    "link": "{{region}} bo'yicha «{{search}}» e'lonlarini ko'rish?",
    "feedTitle": "Sizga mos kelishi mumkin"
  },
  "emptyCategory": {
    "title": "Hozircha bu bo'limda shahringizda e'lonlar yo'q",
    "text": "E'lon joylashtiring va birinchi bo'ling"
  },
  "filters": {
    "drawerDescription": "Kerakli filtrlarni tanlang va «E'lonlarni ko'rsatish» tugmasini bosing",
    "modalTitle": "Filtrlar",
    "clear": "Tozalash",
    "clearAll": "Barcha filtrlarni tozalash",
    "nothingFound": "Hech narsa topilmadi",
    "nothingFoundMessage": "Iltimos, so'rovingizni o'zgartiring yoki ro'yxatdan variantni tanlang",
    "apply": "E'lonlarni ko'rsatish",
    "applyWithCount": "{{count}} ta e'lonlarni ko'rsatish",
    "showAllOptions": "Hammasi",
    "showMoreOptionsWithCount": "Yana {{count}} ta",
    "additional": "Qo'shimcha",
    "dealConditions": "Bitim shartlari",
    "urgent": "Shoshilinch. Savdo.",
    "courierDelivery": "Kuryer yetkazib berish",
    "forFree": "Bepul beraman",
    "currency": {
      "title": "Valyuta",
      "offer": "E'londan",
      "uzs": "So'mda",
      "usd": "y.e. da"
    },
    "price": {
      "title": "Narx",
      "placeholderFrom": "Dan",
      "placeholderTo": "Gacha",
      "validation": {
        "endGreaterThanStart": "Yakuniy narx boshlang'ich narxdan katta bo'lishi kerak",
        "positiveValue": "Musbat qiymat kiriting"
      }
    },
    "range": {
      "placeholderFrom": "Dan",
      "placeholderTo": "Gacha"
    },
    "categories": {
      "title": "Kategoriya",
      "allSelected": "Hammasi",
      "allCategories": "Barcha kategoriyalar",
      "filterTitle": "Kategoriyalar",
      "searchPlaceholder": "Nomini kiriting",
      "allCategoryItems": "Kategoriyaning barcha tovarlari",
      "emptyTitle": "Hech narsa topilmadi",
      "emptyText": "Iltimos, so'rovni o'zgartiring yoki ro'yxatdan variantni tanlang"
    },
    "region": {
      "title": "Qayerdan izlash"
    }
  },
  "geo": {
    "all": "Barcha hududlar",
    "title": "Shahar yoki hududni tanlang",
    "findMe": "Joylashuvimni aniqlash",
    "turnOn": "Joylashuvni aniqlashni yoqish",
    "notSupported": "Sizning hududingiz qo'llab-quvvatlanmaydi",
    "allRegion": "Butun viloyat",
    "indicate": "Shahar, hudud nomini kiriting yoki ro'yxatdan tanlang",
    "warningTitle": "Ta'qiqni olib tashlash kerak",
    "warningText": "Sizda geolokatsiyani aniqlash ta'qiqlangan. Brauzer sozlamalaridan o'zgartiring va qayta urinib ko'ring. Bu manzilingizni aniqlashga yordam beradi.",
    "confirm": {
      "title": "Sizning hududingiz {{region}}?",
      "accept": "Ha",
      "change": "Boshqasini tanlash"
    }
  },
  "free": "Bepul",
  "price": {
    "from": "{{price}} dan",
    "negotiable": "Narx kelishiladi"
  },
  "main": "Asosiy",
  "search": {
    "filter": "{{name}} qidirish",
    "complaint": "Vaziyatni tasvirlang",
    "placeholder": "iPhone 15 Pro topish",
    "searchMobile": "Nike krossovkalar",
    "goToCategory": "Kategoriyaga o'tish"
  },
  "empty": {
    "title": "Biz hech narsa topmadik",
    "searchText": "So'rovni boshqacha kiriting yoki cheklovlarni yumshating",
    "favoriteTitle": "Siz hali hech narsani saqlamadingiz",
    "favoriteText": "E'lonlarni tanlanganlarga saqlang, shunda hech narsani o'tkazib yubormaysiz",
    "favoriteTitlePublicProfile": "Sevimlilar bo'sh",
    "favoriteTextPublicProfile": "Hech narsani o'tkazib yubormaslik uchun e'lonlar va profillarni saqlash uchun tizimga kiring",
    "activeOffersText": "Bu yerda sizning e'lonlaringiz joylashadi",
    "draftOffersText": "Bu yerda e'lonlaringizning qoralamalari bo'ladi",
    "moderationOffersText": "Bu yerda moderatsiyadan o'tgan yoki nashr muddati tugagan e'lonlaringiz joylashadi",
    "archiveOffersText": "Bu yerda yopilgan e'lonlaringiz bo'ladi",
    "selectText": "So‘rovni boshqacha kiriting",
    "selectCategoryText": "Iltimos, so‘rovni o‘zgartiring yoki ro‘yxatdan kategoriyani tanlang",
    "accountNotFound": "Akkaunt topilmadi"
  },
  "drafts": {
    "offerWithoutPrice": "Narx ko'rsatilmagan",
    "offerWithoutTitle": "Nomi ko'rsatilmagan",
    "offerWithoutLocation": "Manzil ko'rsatilmagan"
  },
  "seller": {
    "title": "Mening e'lonlarim",
    "bannersTitle": "Siz uchun foydali",
    "tabs": {
      "active": "Faollar",
      "archive": "Arxiv",
      "draft": "Qoralamalar",
      "moderation": "Harakat kutmoqda"
    },
    "offerImageAltText": "Mahsulot tasviri"
  },
  "buttons": {
    "complaint": "Shikoyat qilish",
    "copied": "Nusxalandi",
    "next": "Keyingi",
    "back": "Orqaga",
    "send": "Yuborish",
    "close": "Yopish",
    "closeOffer": "E’lonni yopish",
    "done": "Tayyor",
    "showMore": "Yana ko'rsatish",
    "put": "Qo'yish",
    "catalog": "Katalog",
    "search": "Qidiruv",
    "home": "Asosiy sahifa",
    "ok": "OK",
    "call": "Qo'ng'iroq qilish",
    "choose": "Tanlash",
    "apply": "Qo'llash",
    "more": "Yana",
    "showAll": "Hammasini ko‘rsatish",
    "collapse": "Yig‘ish",
    "hide": "Yashirish",
    "addFavorite": "Sevimlilarga qo'shish",
    "removeFavorite": "Sevimlilardan o'chirish",
    "entry": "Kirish",
    "entryOrRegister": "Kirish yoki ro'yxatdan o'tish",
    "entryOrCreateProfile": "Profil yaratish yoki profilga kirish",
    "profile": "Profil",
    "myProfile": "Mening profilim",
    "myAds": "Mening e'lonlarim",
    "favorite": "Sevimlilar",
    "toFavorite": "Sevimlilarga",
    "wallet": "Hamyon",
    "settings": "Sozlamalar",
    "exit": "Chiqish",
    "extend": "Uzaytirish",
    "extend30": "30 kunga uzaytiring",
    "statistics": "Statistika",
    "statisticsOffer": "E’lon statistikasi",
    "cancel": "Bekor qilish",
    "exitConfirm": "Ha, chiqish",
    "save": "Saqlash",
    "sell": "Sotish",
    "changeProfile": "Profilni o’zgartirish",
    "deleteAccount": "Akkaunti o'chirish",
    "deleteAccountConfirm": "Ha, o'chirish",
    "anotherCategory": "Boshqa kategoriya",
    "selectCategory": "Kategoriyani tanlash",
    "putAd": "E'lon qo'yish",
    "edit": "Tahrirlash",
    "tryAgain": "Qayta urinish",
    "join": "Qo‘shilish",
    "toAds": "Eʼlonlarni qidirish",
    "selectAll": "Hammasini tanlash",
    "promotion": "Reklama",
    "buyPromotion": "Reklama sotib olish",
    "buyMorePromotion": "Yana reklama sotib olish",
    "connectedPromotion": "Ulangan reklama",
    "payPromotion": "Reklamani to'lash",
    "payAmount": "{{amount}} to'lash",
    "publish": "Nashr qilish",
    "publishAgain": "Qayta joylash",
    "good": "Yaxshi",
    "skip": "O'tkazib yuborish",
    "continue": "Davom ettirish",
    "gotIt": "Tushundim",
    "signIn": "Profilga kirish",
    "reload": "Sahifani yangilash",
    "favoriteSellerButton": "Obuna bo'lgansiz",
    "favoriteSubscribeButton": "Obuna bo'lish",
    "favoriteUnsubscribeButton": "Obunani bekor qilish",
    "shareProfile": "Profilni ulashish",
    "translate": "Tarjima qilish",
    "showOriginal": "Aslini ko'rsatish",
    "chat": "Xabarlar",
    "chatBirBir": "Chat BirBir",
    "telegram": "Telegram",
    "trackPrice": "Narxni kuzatish",
    "supportService": "Qo'llab-quvvatlash xizmati",
    "tryOnceMore": "Qayta harakat qilish",
    "verification": "ID tasdiqlashdan o‘ting",
    "passVerification": "ID tasdiqlashdan o‘tish",
    "resendAgain": "Qayta yuborish",
    "remove": "O‘chirish",
    "contactSupport": "Qo‘llab-quvvatlashga yozish",
    "unblock": "Blokdan chiqarish",
    "showPhoneNumber": "Telefonni ko‘rsatish",
    "goToProfile": "Profilga o‘tish",
    "goToOffer": "E’longa o‘tish",
    "block": "Bloklash",
    "download": "Yuklab olish",
    "announcements": "E'lonlar",
    "birBirForBusiness": "BirBir biznes uchun",
    "myReviews": "Mening sharhlarim",
    "allCategories": "Barcha toifalar",
    "share": "Ulashish",
    "copyLink": "Havolani nusxalash",
    "all": "Hamma",
    "viewAll": "Hammasini ko‘rish",
    "clear": "Tozalash"
  },
  "tabBar": {
    "search": "Qidiruv",
    "favorite": "Sevimlilar",
    "catalog": "Katalog",
    "sell": "Sotish",
    "messages": "Xabarlar",
    "profile": "Profil"
  },
  "filesUpload": {
    "chooseFiles": "Fayllarni tanlang",
    "annotation": "yoki ularni shu yerga tortib tashlang\n(JPG, PNG, {{maxMb}} MB gacha, 300x300 dan kichik emas)",
    "dragCaption": "Fayllarni bu yerga torting",
    "primaryPhoto": "Asosiy",
    "error": "Xato",
    "validationError": "Hech bo‘lmaganda 1 ta rasm qo‘shing",
    "makePrimary": "Asosiy qilish",
    "cancel": "Bekor qilish",
    "errors": {
      "TOO_SMALL_IMAGE": "Minimal o‘lcham 300x300 px",
      "FILE_TOO_LARGE": "Fayl hajmi {{maxMb}} MB dan katta. Kichikroq fayl tanlang."
    }
  },
  "appDownload": {
    "features": {
      "catalogTitle": "1 mln+\ne’lonlar",
      "catalogText": "Yangi va ishlatilgan tovarlar, avto, ko‘chmas mulk va xizmatlar",
      "chatTitle": "Xavfsiz\nBirBir chati",
      "chatText": "Avtotarjimadan foydalanib savdolashing va muloqot qiling",
      "sellersTitle": "Tekshirilgan sotuvchilar",
      "sellersText": "Sharhlar, e’lonlar moderatsiyasi, MyID tekshiruvi",
      "appTitle": "BirBir ilovasida ko‘proq imkoniyatlar",
      "sectionLabel": "BirBir imkoniyatlari"
    },
    "schemaDescription": "BirBir - O'zbekistondagi yangi zamonaviy e'lonlar xizmati",
    "title": "E'lon qo'yish bepul ilovamizda amalga oshirilishi mumkin, va unda:",
    "footerText": "Mobil ilovani yuklab oling",
    "discussion": "Bitimni telegramda muhokama qilish mumkin",
    "observation": "Yangilanishlarni kuzatib borish mumkin",
    "favourite": "Mahsulotlarni saqlash mumkin",
    "smartBanner": {
      "title": "BirBir — Oʻzbekistondagi eʼlonlar",
      "cta": "Yuklab olish",
      "dismissAriaLabel": "Bannerni yopish",
      "ratingAriaLabel": "Reyting: {{outOf}} dan {{rating}}"
    }
  },
  "about": {
    "topBanner": "BirBir — bu onlayn e’lonlar platformasi",
    "bottomBanner": "BirBirga qo‘shiling — xarid qiling va soting!",
    "aimTitle": "Bizning maqsadimiz",
    "aimText": "Insonlar o‘rtasida to‘g‘ridan-to‘g‘ri bitimlar uchun qulay va xavfsiz muhit yaratishdir. BirBir — bu vositachilarsiz, har ikki tomon uchun ham foydali bo‘lgan «win-win» (g‘olib-g‘olib) bitimlar. Onlayn platformamiz xaridorlar va taklif qiluvchilarni bir joyda birlashtirib, ularga savollar berish, tovar haqida ma’lumot olish, narxni kelishish va xavfsiz bitim tuzish imkoniyatini yaratadi.",
    "missionTitle": "Bizning missiyamiz",
    "missionText": "O‘zbekistonda odamlar o‘rtasidagi oldi-sotdi <br/> uchun qulay va ishonchli muhitni yaratishdir.",
    "advantagesTitle": "Nega aynan BirBir?",
    "card1": {
      "title": "Unumli, qulay, xavfsiz",
      "text": "BirBirda turli xil tovarlarni xarid qilish, sotish hamda xizmatlarni taklif qilish yoki buyurtma berish mumkin"
    },
    "card2": {
      "title": "Soddа va tushunarli interfeys",
      "text": "Xaridorlarga takliflarni tez topishga, sotuvchilarga esa e’lon joylashtirish va bitim tuzishga yordam beradi"
    },
    "card3": {
      "title": "Xizmat imkoniyatlari",
      "text": "Kiyim-kechak sotib olish, avtomobil yoki keraksiz narsalarni sotish, uy-joyni ijaraga berish yoki olish, xizmat taklif etish mumkin"
    },
    "advantage1": {
      "title": "Keng tanlov",
      "text": "Yangi va ishlatilgan tovarlar, noyob topilmalar, turli toifadagi xizmatlar va aksiya takliflari"
    },
    "advantage2": {
      "title": "To‘g‘ridan-to‘g‘ri bitimlar",
      "text": "Vositachilar qo‘shimcha to‘lovlar va yashirin ustamalarsiz jarayonlar"
    },
    "advantage3": {
      "title": "Qulaylik",
      "text": "Mobil ilovada tez qidiruv, «aqlli» tavsiyalar va sun’iy intellekt yordamida e’lonlarni takomillashtirish"
    },
    "advantage4": {
      "title": "Xavfsizlik",
      "text": "E’lon berishdan oldin profil tekshiruvi, sotuvchilar va e’lonlarni qat’iy nazorati"
    },
    "advantage5": {
      "title": "Shaxsiy muloqot",
      "text": "Bitim ishtirokchisi bilan narx, to‘lov shartlari, yetkazib berish usullari va boshqa tafsilotlarni muhokama qilish imkoniyati"
    },
    "advantage6": {
      "title": "Soddalik",
      "text": "Insonlar tomonidan insonlar uchun yaratilgan platforma — qidiruvdan bitim tuzishgacha atigi bir qadam"
    }
  },
  "favorite": {
    "title": "Sevimlilar",
    "offersTab": "E'lonlar",
    "followsTab": "Profillar",
    "sectionTitle": "Sizga yoqishi mumkin",
    "loginButton": "Profilga kirish",
    "preview": {
      "viewAll": "Hammasini ko'rish"
    }
  },
  "favoriteSeller": {
    "offersCount_one": "{{count}} e'lon",
    "offersCount_other": "{{count}} e'lon",
    "hasNoOffers": "Faol e'lonlar yo'q",
    "deleted": "Profil o'chirildi",
    "guest": "Mehmon",
    "showMore": "Ko'proq ko'rsatish",
    "showLess": "Kamroq ko'rsatish"
  },
  "sellerSelection": {
    "title": "Sotuvchining e'lonlari",
    "searchPlaceholder": "Sotuvchida topish",
    "goToCategory": "Kategoriyaga o'tish",
    "emptyTitle": "Bu sotuvchida hech narsa topilmadi",
    "emptyText": "So'rovni o'zgartiring yoki boshqa e'lonlarni ko'ring",
    "recommendationsTitle": "Sizga yoqishi mumkin"
  },
  "publicSeller": {
    "registered": "BirBir'da {{date}} dan beri",
    "offersTitle": "E'lonlar",
    "activeOffersTitle": "Faol e'lonlar",
    "searchEntry": "Sotuvchida topish ({{count}})",
    "offersCount_one": "e'lon",
    "offersCount_other": "e'lon",
    "followersCount_one": "Obunachi",
    "followersCount_other": "obunachilar",
    "rating": "Reyting",
    "noRating": "Baholar yoʻq",
    "noFeed": "Foydalanuvchida faol/n e’lon yo‘q",
    "guest": "Mehmon",
    "reviewsTitle": "Foydalanuvchi haqida sharhlar",
    "reviewTitleMy": "Sharhlarim",
    "reviewTitleBusiness": "Do‘kon haqida sharhlar",
    "reviewsRate": "Baholash",
    "reviewsAdd": "Sharh qoldirish",
    "reviewsEmpty": "Sharhlar yo‘q",
    "reviewsCount_one": "{{count}} ta sharh",
    "reviewsCount_other": "{{count}} ta sharh",
    "reviewsSuggestion": "Sotuvchi yoki mahsulot\nhaqida sharh qoldiring",
    "reviewsShare": "Profilni ulashish",
    "reviewsEmptyTitle": "Dastlabki sharhlarni olish uchun e’lon joylashtiring va profilingizni ulashing",
    "reviewsEmptyText": "Sharhlar ishonchni oshiradi\nva ko‘proq xaridorlarni jalb qiladi",
    "becomeSellerTitle": "Hozir sotishni boshlang",
    "becomeSellerAction": "E'lon yaratish"
  },
  "home": {
    "bannersTitle": "Foydali va qulay",
    "feedTitle": "Qiziqarli",
    "feedTitleRegion": "{{whereTitle}} qiziqarli",
    "allCategories": "Barcha kategoriyalar →"
  },
  "newOffer": {
    "title": "Yangi e'lon",
    "editTitle": "E’lonni tahrirlash",
    "auth": {
      "title": "Avtorizatsiya",
      "hint": "E’lonni joylashtirish uchun akkauntingizga kiring"
    },
    "saveDraft": "Qoralamalarga saqlash"
  },
  "menu": {
    "title": "Menyu",
    "support": "Qo'llab-quvvatlash",
    "home": "Asosiy",
    "blog": "Blog",
    "about": "Biz haqimizda",
    "regions": "Barcha hududlar",
    "documents": "Platforma qoidalari",
    "categories": "Kategoriyalar",
    "authors": "Mualliflar",
    "service": "Xizmatlar"
  },
  "gallery": {
    "title": "{{ current }} dan {{ total }}",
    "errorTitle": "Rasm yuklanmadi",
    "errorSolving": "Internet aloqasini tekshiring",
    "previousImage": "Oldingi rasm",
    "nextImage": "Keyingi rasm"
  },
  "languageTitle": "Tilni tanlang",
  "errorTitle": "Xatolik yuz berdi",
  "repeatTitle": "Qayta urinib ko'ring",
  "complaint": {
    "title": "E'lon bo'yicha shikoyat",
    "successTitle": "Yordam uchun rahmat",
    "successText": "Bunday murojaatlar xizmatimizdagi e'lonlarning sifatini yaxshilaydi."
  },
  "notFound": {
    "title": "Sahifa topilmadi",
    "text": "Ammo bizda boshqa qiziqarli mahsulotlar va kategoriyalar bor"
  },
  "serverError": {
    "title": "Ulanish uzildi",
    "text": "Serverda xatolik yuz berdi, ammo biz uni tuzatmoqdamiz. Iltimos, sahifani yangilab ko‘ring"
  },
  "phone": "Telefon",
  "popular": "Ommabop",
  "similarFeed": {
    "title": "O'xshash e'lonlar",
    "tooltip": "O'xshash tovarlarni qidiring",
    "empty": "Hozircha o'xshash e'lonlar yo'q"
  },
  "offer": {
    "number": "E’lon №",
    "publicationTime": "Joylandi",
    "views": "Tomoshalar",
    "features": "Xususiyatlar",
    "description": "Tavsif",
    "details": "E’lon tafsilotlari",
    "place": "Bitim joyi",
    "similar": "O'xshashlar",
    "other": "Sotuvchining boshqa e'lonlari",
    "contact": "Sotuvchiga yozish",
    "deliveryText": "Yetkazib berish mumkin",
    "landmark": "Mo'ljal",
    "contactsListTitle": "Aloqa ma'lumotlari",
    "deliveryTitle": "Sotuvchi yetkazib berishni tashkil qilishga\ntayyor ekanligini aytdi",
    "deliveryDescription": "Diqqat: BirBir buyumlarni yetkazib berishni amalga oshirmaydi.\nIltimos, bank ma'lumotlaringizni bermang.",
    "guest": "Mehmon",
    "online": "Onlayn",
    "activeOffersCount": "{{count}} ta faol e'lon",
    "onPlatform": "BirBir'da",
    "sellerPhone": "Sotuvchining raqami",
    "call": "Bog‘lanish",
    "relatedTitle": "Boshqa e’lonlarni ko‘ring",
    "relatedText": "Shu kategoriyaga o‘ting yoki quyidagi boshqa e’lonlarni ko‘ring",
    "relatedLink": "Kategoriyaga o‘tish",
    "expiredOfferMessage": "E’lon nashrdan olib tashlandi",
    "closed": {
      "showFull": "To‘liq ko‘rish",
      "hideFull": "Yig‘ish",
      "registered": "Ro‘yxatdan o‘tgan {{date}}",
      "openGallery": "Foto galereyani ochish — {{title}}",
      "categoryCard": {
        "title": "Kategoriyadagi barcha e’lonlar",
        "subtitle": "«{{categoryName}}» bo‘limidagi barcha takliflarni ko‘ring",
        "subtitleFallback": "Xuddi shu kategoriyadagi o‘xshash takliflarni ko‘ring",
        "cta": "Kategoriyaga o‘tish"
      }
    },
    "count_one": "{{count}} e'lon",
    "count_other": "{{count}} e'lon",
    "translationWarn": "Tarjima aniq bo‘lmasligi mumkin",
    "askSeller": {
      "title": "Sotuvchidan so’rang",
      "optionsLabel": "Savol variantlari",
      "inputLabel": "Sizning savolingiz",
      "sendLabel": "Yuborish"
    },
    "offerBid": {
      "customAmountPlaceholder": "Istalgan summani kiriting",
      "optionsLabel": "Narx variantlari",
      "title": "O‘z narxingizni taklif qiling",
      "inputLabel": "Sizning narxingiz",
      "sendLabel": "Yuborish"
    },
    "goodPrice": {
      "title": "Nega narx yaxshi?",
      "description": "Biz bu e'lonni BirBirdagi shunga o'xshash e'lonlar bilan solishtirdik: sotuvchi ko'rsatgan toifa, model, xususiyatlar va holatini hisobga oldik. Narx foydali ko'rinadi, ammo xarid qilishdan oldin tovar tafsilotlarini sotuvchidan aniqlab olish yaxshiroq."
    }
  },
  "loan": {
    "advertisement": "Reklama sifatida",
    "applyButton": "Ariza berish",
    "period": "oyiga",
    "loanType": "Ipoteka bankdan mikrozaym"
  },
  "documentsList": {
    "active": {
      "title": "BirBir qoidalari",
      "subtitle": "Bu yerda BirBir faoliyat yuritadigan qoidalar va huquqiy ma’lumotlar to’plangan."
    },
    "archive": {
      "title": "Yuridik hujjatlar arxivi",
      "subtitle": "Arxivda platformaning avvalgi yuridik hujjat versiyalari mavjud"
    }
  },
  "meta": {
    "bulletinBoard": "E'lonlar taxtasi",
    "announcements": "E'lonlar",
    "postAd": "Bepul e'lon joylashtiring yoki mahsulot sotib oling. Savdolashish mumkin.",
    "bulletinBoardInUzbekistan": "O'zbekistonda e'lonlar taxtasi",
    "appTitle": "BirBir mobil ilovasini yuklab oling",
    "appDescription": "BirBir mobil ilovasini yuklab oling. App Store va Google Play'da mavjud.",
    "websiteSchema": "E'lonlar. Bepul e'lon joylashtiring yoki mahsulot sotib oling. Savdolashish mumkin.",
    "aboutTitle": "BirBir kompaniyasi haqida",
    "aboutDescription": "BirBir kompaniyaning missiya, qadriyatlar va yangiliklar haqida. BirBir – tovarlar, ko‘chmas mulk, ish o‘rinlari va ish qidiruvchilar rezyumesi hamda xizmatlar bo‘yicha e’lonlar joylashtirish uchun mo'ljallangan O'zbekistondagi internet platformasi.",
    "regionsTitle": "O'zbekistonning barcha viloyatlari",
    "regionsDescription": "Ushbu sahifada O'zbekiston Respublikasi bo'yicha BirBir e'lonlar xizmati faoliyat ko'rsatadigan shaharlar va posyolkalar ro'yxati keltirilgan.",
    "documentsTitle": "BirBir qoidalari va huquqiy ma'lumotlar",
    "documentsDescription": "BirBir platformasidan foydalanish qoidalari va shartlari sahifasi. Iltimos, platforma qoidalari va O‘zbekiston Respublikasi qonunlariga rioya qiling.",
    "categoryTitle": "{{categoryLowerTitle}} {{whereTitle}}",
    "searchTitle": "«{{search}}»: {{whereTitle}} e'lonlari",
    "categoryDescription": "{{categoryLowerTitle}} {{whereTitle}} tez va yaxshi narxda sotib olish yoki sotish. {{whereTitle}} {{categoryLowerTitle}}: barcha modellari, narxi, suratlari va xususiyatlari BirBir servisida.",
    "categoryWithFilterTitle": "{{filterOptionCapitalizedValue}} {{categoryLowerTitle}} {{whereTitle}}",
    "categoryWithFilterDescription": "{{filterOptionCapitalizedValue}} {{categoryLowerTitle}} {{whereTitle}} tez va yaxshi narxda sotib olish yoki sotish. {{whereTitle}} {{filterOptionCapitalizedValue}} {{categoryLowerTitle}}: barcha modellari, narxi, suratlari va xususiyatlari BirBir servisida.",
    "homeSchemaName": "E’lonlar {{region}} — BirBir",
    "homeSchemaDescription": "Sotib olish, sotish va ijaraga berish {{region}}: avtomobillar, ko‘chmas mulk, xizmatlar, texnika, bolalar tovarlari va boshqalar. Hammasi bitta platformada — BirBir.",
    "cityPageDefaultTitle": "{{whereTitle}} e'lonlar",
    "cityPageAllRegionsTitle": "O‘zbekistonda e'lonlar",
    "blogTitle": "BirBir blogi: Oʻzbekistondagi eʼlonlar bo’yicha maslahatlar, sharhlar va yangiliklar",
    "blogDescription": "BirBir axborot blogi — Oʻzbekistondagi mahsulotlar, xizmatlar, ko’chmas mulk va onlayn eʼlonlar haqida amaliy maqolalar. Xaridorlar, sotuvchilar va eʼlonlar platformasi foydalanuvchilari uchun foydali.",
    "blogTagsTitle": "BirBir blogi teglari: maqolalar va materiallar mavzulari",
    "blogTagsDescription": "BirBir blogidagi barcha mavzuli teglar roʻyxati keltirilgan sahifa. Qiziqtirgan mavzu bo’yicha materiallarni qulay topish va ko’rish uchun ishlatiladi.",
    "blogAuthorsTitle": "BirBir blogi mualliflari: mualliflar, mutaxassislar va chop etilgan materiallar roʻyxati",
    "blogAuthorsDescription": "BirBir blogi mualliflari va ularning nashrlari keltirilgan sahifa. Har bir muallif mahsulotlar, xizmatlar, ko’chmas mulk, onlayn eʼlonlar hamda Oʻzbekistondagi hayotga oid foydali maslahatlar haqida maqolalar yozadi."
  },
  "assets": {
    "images": {
      "qrCode": "application_qr-code.webp"
    },
    "banners": {
      "main": {
        "image": "main_834_uz.webp",
        "image2x": "main_834_uz_2x.webp",
        "smallImage": "main_430_uz.webp",
        "smallImage2x": "main_430_uz_2x.webp",
        "tabletImage": "main_1024_uz.webp",
        "tabletImage2x": "main_1024_uz_2x.webp",
        "desktopImage": "main_1440_uz.webp",
        "desktopImage2x": "main_1440_uz_2x.webp"
      },
      "appFeatures": {
        "catalog": {
          "lg": "app-banner-catalog-lg.webp",
          "lg2x": "app-banner-catalog-lg_2x.webp",
          "md": "app-banner-catalog-md.webp",
          "md2x": "app-banner-catalog-md_2x.webp",
          "sm": "app-banner-catalog-sm.webp",
          "sm2x": "app-banner-catalog-sm_2x.webp"
        },
        "chat": {
          "lg": "app-banner-chat-lg.webp",
          "lg2x": "app-banner-chat-lg_2x.webp",
          "md": "app-banner-chat-md.webp",
          "md2x": "app-banner-chat-md_2x.webp",
          "sm": "app-banner-chat-sm.webp",
          "sm2x": "app-banner-chat-sm_2x.webp"
        },
        "sellers": {
          "lg": "app-banner-sellers-lg.webp",
          "lg2x": "app-banner-sellers-lg_2x.webp",
          "md": "app-banner-sellers-md.webp",
          "md2x": "app-banner-sellers-md_2x.webp",
          "sm": "app-banner-sellers-sm.webp",
          "sm2x": "app-banner-sellers-sm_2x.webp"
        }
      },
      "blog": {
        "image": "blog-banner.webp",
        "smallImage": "blog-banner-mobile.webp"
      }
    }
  },
  "downloadButtons": {
    "appStoreCaption": "Yuklab oling",
    "googlePlayCaption": "Mavjud",
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "chip": {
    "removeAriaLabel": "{{label}}ni olib tashlash",
    "notificationDot": "bildirishnoma bor"
  },
  "badge": {
    "delivery": "Yetkazib berish",
    "shop": "Do'kon",
    "agency": "Agentlik",
    "pro": "PRO",
    "idVerified": "ID tasdiqlangan",
    "idUnverified": "ID не tasdiqlanmagan",
    "urgentSale": "Narx kelishiladi",
    "inTwoHours": "2 soat ichida",
    "advertisement": "Reklama"
  },
  "sellerModals": {
    "pro": {
      "title": "PRO hisob",
      "description": "Bu belgi foydalanuvchi professional sotuvchi ekanini bildiradi."
    },
    "verified": {
      "title": "Profil tasdiqlangan",
      "description": "Bu belgi profil MyID xizmati orqali tasdiqlanganini bildiradi."
    }
  },
  "distance": {
    "km": "{{distance}} km"
  },
  "feedCard": {
    "todayAt": "Bugun, {{time}}"
  },
  "goodPrice": {
    "label": "Yaxshi narx"
  },
  "sidebar": {
    "myProfile": "Mening profilim",
    "advertisement": "Mening e'lonlarim",
    "favorite": "Sevimlilar",
    "chat": "Xabarlar",
    "business": "BirBir biznes uchun",
    "support": "Qo'llab-quvvatlash xizmati",
    "language": "Til ({{language}})",
    "changeLanguage": "Tilni o'zgartirish",
    "aboutUs": "Biz haqimizda",
    "rules": "Platforma qoidalari",
    "verification": "ID tasdiqlashdan o‘ting",
    "namelessProfileCaption": "Ismingizni kiriting",
    "lookAtProfile": "Profilim qanday ko‘rinadi",
    "loginOrRegister": "Kirish yoki ro‘yxatdan o‘tish"
  },
  "forms": {
    "login": {
      "title": "Kirish yoki profil yaratish",
      "description": "Xaridorlar sizni bu raqam orqali topishlari mumkin.\nSiz undan avtorizatsiya uchun ham foydalanishingiz mumkin.",
      "conditions": "Avtorizatsiyadan o'tib, siz shaxsiy <policy>ma'lumotlarni qayta ishlash siyosati</policy> va <agreement>foydalanuvchi shartnomasiga</agreement> rozilik bildirasiz",
      "requestCode": "Kod olish"
    },
    "otp": {
      "title": "SMSdan kelgan kodni kiriting",
      "sentTo": "{{phone}} ga yuborildi",
      "sentToOnMobile": "Biz sizga uni\n{{phone}} raqamiga yubordik",
      "requestCode": "Kod olish",
      "replyRequest": "Kodni qayta so'rash {{seconds}} soniyadan keyin mumkin"
    },
    "profile": {
      "title": "Profilni o’zgartirish",
      "namePlaceholder": "Ismingizni kiriting",
      "contactPreference": "Siz bilan bog'lanishning afzal usuli",
      "birBirChat": "Chat BirBir",
      "enabledByDefault": "Sukut bo'yicha yoqilgan",
      "phoneCalls": "Qo'ng'iroq orqali",
      "telegramChat": "Telegramda suhbat",
      "telegramPhoneNumber": "raqam bo'yicha {{phoneNumber}}"
    },
    "verification": {
      "title": "ID tasdiqlanmoqda",
      "birthDate": "Tug‘ilgan sana",
      "passport": "ID yoki pasport seriyasi va raqami",
      "passportSeries": "Seriya",
      "passportNumber": "Raqam",
      "disclaimer": "Davom etish tugmasini bosish orqali siz <policy>shaxsiy ma’lumotlarni qayta ishlash siyosati</policy> va <agreement>foydalanuvchi shartnomasi</agreement> bilan rozilik bildirasiz"
    },
    "fragments": {
      "photos": {
        "label": "Rasmlar (1 tadan 10 tagacha)",
        "description": "Tartibini o‘zgartirish uchun rasmlarni torting",
        "descriptionMobile": "JPG, PNG, 10 MB gacha, 300x300 dan kichik emas"
      },
      "title": {
        "label": "Nom",
        "description": "Mahsulot yoki xizmatni qisqacha tavsiflang (50 belgidan oshmasin)",
        "placeholder": "Masalan, 42 o‘lchamli Nike krossovkalar"
      },
      "features": {
        "label": "Xususiyatlar",
        "minValueHint": "Minimal qiymat {{minValue}}",
        "maxValueHint": "Maksimal qiymat {{maxValue}}",
        "betweenMinAndMaxHint": "Qiymat {{valueMin}} dan {{valueMax}} gacha bo‘lishi kerak",
        "selectPlaceholder": "Qidirish uchun ma'lumotlarni kiriting"
      },
      "category": {
        "label": "Kategoriya",
        "noEditMessage": "E’lonni tahrirlashda toifani o‘zgartira olmaysiz"
      },
      "conditions": {
        "label": "Bitim shartlari",
        "free": "Tekinga beraman",
        "price": {
          "title": {
            "fixed": "Narxi",
            "negotiable": "Eng kam narx"
          },
          "placeholder": {
            "fixed": "Narxini kiriting",
            "negotiable": "dan"
          },
          "error": "Narxini kiriting",
          "urgent": "Savdolashish mumkin"
        }
      },
      "description": {
        "label": "Tavsif",
        "description": "Masalan: «Qora Nike krossovkalari, 42-razmer. Holati a'lo — atigi bir necha marta kiyilgan. O‘lchami to‘g‘ri kelmagani uchun sotilyapti».",
        "placeholder": "Mahsulot yoki xizmat haqida gapirib bering"
      },
      "location": {
        "label": "Bitim joyi",
        "description": "Xaridorlarga sotib olishni oson rejalashtirish va siz bilan tezroq bog‘lanish uchun haqiqiy uchrashuv joyini kiriting",
        "defaultSearch": "Toshkent",
        "address": "Manzil",
        "addressPlaceholder": "Manzil, do‘kon yoki metro",
        "addressError": "Manzilni kiriting",
        "mark": "Mo'ljal",
        "markPlaceholder": "Masalan, oloy bozori",
        "courierDelivery": "Yetkazib berishni tashkil qila olaman"
      },
      "contacts": {
        "label": "Aloqa ma'lumotlari",
        "phoneInputLabel": "Telefon",
        "nameInputLabel": "Ism"
      },
      "contactWays": {
        "label": "Aloqa usullari",
        "description": "Hech bo‘lmaganda bitta aloqa usulini tanlash kerak"
      }
    }
  },
  "modals": {
    "deleteAccount": {
      "initial": {
        "title": "Akkaunt o‘chirilsinmi?",
        "description": "Sizning e’lonlaringiz, qidiruv tarixingiz va saqlab qo‘ygan narsalaringiz o‘chirib tashlanadi. Bu amalni qaytarib bo‘lmaydi."
      },
      "success": {
        "title": "Sizning hisobingiz o'chirildi",
        "description": "Barcha postlaringiz va platforma bilan ishlash tarixingizni olib tashladik"
      }
    },
    "logout": {
      "title": "Profildan chiqish?",
      "description": "Telefon raqami orqali \nyana kirishingiz mumkin"
    },
    "selectCategory": {
      "title": "Kategoriya",
      "inputPlaceholder": "Topish"
    },
    "ad": {
      "successTitle": "E'loningiz tekshiruvda",
      "successDescription": "E’loningizni e’lonlar ro‘yxatidan topishingiz mumkin.",
      "failureDescription": "E’lon joylanmadi, lekin qoralamalarda saqlandi. Iltimos, takror qib ko‘ring."
    },
    "closeAd": {
      "title": "E'lonni yopish sababini tanlang"
    },
    "closeOffer": {
      "title": "Sababini ko'rsating",
      "description": "E’loningiz nashrdan olib tashlanadi va arxivga joylashtiriladi.",
      "promotionDescription": "E'loningizga reklama ulangan. U to‘xtatiladi va e'lon qayta joylashtirilganda davom ettiriladi"
    },
    "promoteOffer": {
      "title": "E’loningizni yanada ko’rinarli qiling",
      "footerHint": "\"To'lash\" tugmasini bosish orgali siz <document>taklif</document> shartlari bilan rozi bo'vosiz",
      "day": "{{count}} kun"
    },
    "offerPromotions": {
      "title": "Faol xizmatlar",
      "offer": "{{title}}: {{price}} uchun {{duration}}"
    },
    "offerPromotionsPayment": {
      "title": "Reklama to‘langan",
      "description": "Ulangan xizmatlar",
      "errorTitle": "To‘lov amalga oshmadi",
      "errorDescription": "Reklamani keyinroq rasmiylashtirib ko‘ring.\nBuni e’lonlaringiz ro‘yxatida qilishingiz mumkin."
    },
    "offerStatistics": {
      "title": "Statistika"
    },
    "downloadApp": {
      "offer": {
        "title": "BirBir ilovasini\n yuklang",
        "content": {
          "title": "BirBir ilovasida davom eting",
          "description": "Xaridorlarga tezroq javob berish, identifikatsiyadan o‘tish, sharhlar haqida xabarnomalar olish va yetkazib berishni kuzatib borish uchun ilovani yuklab oling."
        },
        "image": {
          "phone": "offer_uz.webp"
        }
      },
      "price_track": {
        "title": "BirBir ilovasini\n yuklang",
        "content": {
          "title": "BirBir ilovasida foydali takliflarni kuzatib boring",
          "description": "Siz qiziqayotgan mahsulot narxi pasayganda ilovada bildirishnoma yuboramiz — shunda sevimli sotuvchingizning chegirmalari va yangi mahsulotlari haqida birinchilardan bo‘lib xabardor bo‘lasiz."
        },
        "image": {
          "phone": "price_tracking_uz.webp",
          "highlight": "price_tracking_helper_uz.webp"
        }
      },
      "delivery": {
        "title": "BirBir Yetkazma\n ilova orqali",
        "content": {
          "title": "Yetkazib berishni BirBir ilovasida rasmiylashtirishingiz mumkin",
          "description": "Toshkent bo‘ylab 2 soat ichida yetkazib berish uchun ilovani yuklab oling va mahsulotlarni uyingizga buyurtma qiling!"
        },
        "image": {
          "phone": "delivery.webp"
        }
      },
      "review": {
        "title": "BirBir Yetkazma\n ilova orqali",
        "content": {
          "title": "Sharh qoldirish uchun, BirBir ilovasini yuklab oling.",
          "description": "Sharhlarni ilova orqali qoldirish mumkin. Uni yuklab oling va fikringizni bo'lishing."
        },
        "image": {
          "phone": "download-app-banner_reviews_uz.webp"
        }
      },
      "registration": {
        "title": "BirBir ilovasini\n yuklab oling",
        "content": {
          "title": "BirBirning barcha imkoniyatlari ilovada",
          "description": "Tezroq soting va sotib oling. Sotuvchilar bilan muloqot qiling va BirBirning barcha imkoniyatlaridan bitta ilovada foydalaning."
        },
        "image": {
          "phone": "registration-download-app-uz.webp"
        }
      }
    },
    "suggestVerification": {
      "title": "BirBirda tasdiqlangan foydalanuvchiga aylaning",
      "description": "Tasdiqlangan foydalanuvchilar ko‘proq ishonch uyg‘otadi. Jarayon xavfsiz va atigi bir necha daqiqa davom etadi.",
      "image": "guard.webp",
      "success": {
        "title": "ID tasdiqlandi",
        "description": "Endi foydalanuvchilar profilingiz tasdiqlanganini bilishadi"
      },
      "failure": {
        "description": "ID hujjatingizni tasdiqlay olmadik"
      }
    }
  },
  "stats": {
    "adViews": {
      "tooltip": "E'loningiz ko‘rilganlar soni",
      "description": "E'loningiz {{count}} marta ko‘rilgan"
    },
    "adSaves": {
      "tooltip": "E’loningiz saqlanganlar soni",
      "description": "E'lon {{count}} marta sevimlilarga saqlangan"
    },
    "contactViews": {
      "tooltip": "Kontaktlaringiz ko’rilganligi va boshlangan chatlar soni",
      "description": "Kontaktlaringiz {{count}} marta ko‘rilgan"
    }
  },
  "regions": {
    "allCategories": "Barcha toifalar {{ region }}"
  },
  "chat": {
    "defaultTitle": "Xabarlar",
    "userNotFound": "Akkaunt topilmadi",
    "userBlocked": "Siz foydalanuvchini blokladingiz.\nXabar yuborish va xabar qabul qilish imkonsiz",
    "messagingRestricted": "Foydalanuvchi kiruvchi xabarlar imkoniyatini chekladi.",
    "yourMessage": "Siz:",
    "offerClosed": "Yopilgan",
    "inputPlaceholder": "Sizning xabaringiz",
    "attachments": {
      "camera": "Kamera",
      "photo": "Rasm yuborish",
      "gallery": "Galereyadan tanlash",
      "location": "Geolokatsiyani yuborish"
    },
    "dialogsPlaceholder": {
      "title": "BirBir chatlarida xavfsizroq",
      "description": "BirBir chatlarida suhbatlashish\nqulayroq va xavfsizroq"
    },
    "chatPlaceholder": {
      "title": "Sotuvchidan tafsilotlarni aniqlashtiring",
      "description": "Hozircha xabarlar yo‘q"
    },
    "userStatus": {
      "online": "Onlayn",
      "recently": "Yaqinda kirgan"
    },
    "errorMessage": "Yetkazilmagan",
    "unreadMessages": "O‘qilmagan xabarlar",
    "today": "Bugun",
    "yesterday": "Kecha",
    "complaint": "Salom!, foydalanuvchi uuid raqami: {{uuid}} bo‘yicha shikoyat qilmoqchiman",
    "blockModalTitle": "Foydalanuvchini bloklash?",
    "blockModalText": "Foydalanuvchi sizga xabar yubora olmaydi, sizning e’lonlaringiz va profilingizni ko‘ra olmaydi. Uni istalgan vaqtda blokdan chiqarishingiz mumkin.",
    "blockConfirm": "Ha, bloklash",
    "autoTranslation": "O‘zbek tiliga avtomatik tarjima",
    "appBanner": {
      "title": "Yangi xabarlarni o‘tkazib yubormang",
      "description": "Bildirishnomalar ilovada mavjud",
      "cta": "Ilovani yuklab olish",
      "close": "Bannerni yopish"
    },
    "photo": "Foto",
    "noMessagesInDialog": "Xabarlar yo‘q",
    "photoMessage": "Foto",
    "locationMessage": "Joylashuv",
    "mapLocation": {
      "title": "Uchrashuv joyi",
      "viewOnlyTitle": "Geolokatsiyani ko‘rish",
      "geoPosition": "Geolokatsiya",
      "searchPlaceholder": "O‘zbekistonda topish",
      "viewOnMap": "Yandex xaritalarda ochish"
    },
    "messageUnsupported": "Bu xabarni hozircha bu yerda ko‘rsatib bo‘lmaydi. Ko‘rish uchun mobil ilovani yuklab oling."
  },
  "blog": {
    "title": "BirBir maslahatlar va ilhom",
    "tags": {
      "all": "Barcha maqolalar",
      "authorArticles": "Muallif maqolalari",
      "authorTags": "Toifalar",
      "authorLinks": "Boshqa nashrlar"
    },
    "authors": {
      "title": "Mualliflar",
      "tabHeadingTags": "Muallif eʼlon qiladigan toifalar",
      "tabHeadingLinks": "Muallifning boshqa resurslardagi materiallariga havolalar",
      "article": "{{count}} ta maqola"
    },
    "article": {
      "navigationTitle": "Mundarija",
      "similarItems": "O'xshash materiallar",
      "editedAt": "Обновлено {{date}}",
      "faq": "Ommabop savollar",
      "banner": {
        "title": "Eng yaxshisini hoziroq toping",
        "description": "Siz uchun eng qiziqarli tovarlarni bir joyga to'pladik"
      }
    }
  },
  "theme": {
    "system": "Tizim",
    "light": "Yorug'",
    "dark": "Qorong'u"
  },
  "monetization": {
    "meta": {
      "title": "BirBirda tez soting. Pullik xizmatlar",
      "description": "BirBirda qanday qilib tezda sotish mumkin? E'lonlarni targ'ib qilish uchun pullik xizmatlardan foydalaning: ko'proq ko'rsatishlar, ko'proq ko'rishlar va tezroq savdolar."
    },
    "hero": {
      "titlePart1": "E'lonlaringizni BirBirda",
      "titleAccent": "ilgari suring",
      "subtitlePart1": "1+ million xaridorga ega O'zbekiston",
      "subtitleBold": "e'lonlar maydonchasida",
      "cta": "E'lon joylashtirish"
    },
    "services": {
      "title": "E'lonlarni targ'ib qilish va sotuvni tezlashtirish usullari",
      "subtitle": "BirBirda qidiruvda ajralib turish va e'loningizni ko'proq odam ko'rishiga yordam beradigan targ'ibot vositalari mavjud",
      "priceNote": "Targ'ibot xizmatlari narxi e'lon toifasiga bog'liq",
      "maxiCard": {
        "title": "Maksi kartochka",
        "feature1": "E'lonlar qidiruvda yuqoriroq o'rinlarda",
        "feature2": "\"Premium\" ko'rinish va kengaytirilgan fotogalereya",
        "feature3": "Aloqa ma'lumotlaringizga to'g'ridan-to'g'ri kirish",
        "feature4": "Mobil versiya va ilovada e'lon rasmi kattaroq",
        "summary": "E'lonni ajratib ko'rsatish kerak bo'lganda qo'l keladi"
      },
      "autoUp": {
        "title": "4 marta yuqoriga",
        "feature1": "Avtomatik ko'tarish 4 marta — 7, 14, 21 va 28-kunlari",
        "feature2": "E'lon lentada xuddi hozirgina joylashtirilgandek yuqoriga ko'tariladi",
        "summary": "E'lon qidiruvda pastga tushib qolgan bo'lsa, qo'l keladi"
      },
      "oneUp": {
        "title": "Bir martalik ko'tarish",
        "feature1": "Istalgan vaqtda qo'lda ko'tarish",
        "feature2": "E'lon lentada xuddi hozirgina joylashtirilgandek yuqoriga ko'tariladi",
        "summary": "E'lon qidiruvda pastga tushib qolgan bo'lsa, qo'l keladi"
      }
    },
    "business": {
      "title": "BirBir biznes uchun",
      "cardTitle": "Tasdiqlangan sotuvchi",
      "cardSubtitle": "Yuridik shaxslar uchun",
      "feature1": "\"Do'kon\" va \"Agentlik\" ishonch nishonlari",
      "feature2": "Shaxsiy biznes-menejer",
      "feature3": "Bepul ulash",
      "cta": "Ariza qoldirish",
      "footerLine1": "Ilovada targ'ibotning yangi usullari sinovdan o'tkazilishi mumkin, ijtimoiy tarmoqlarimizdagi yangiliklarimizni kuzatib boring.",
      "footerLine2": "To'plamli yechimlar ishlab chiqilmoqda."
    }
  }
}
